import { Flex, Table, Typography } from "antd"

import Private from "../../../../Components/Private"
import { ChargebackRateOver100Tooltip, formatAmount, formatCount } from "./columns"

import "./tableSummaryStyles.less"

const { Text } = Typography

const defaultColumnsList = [
  [
    { name: "transactions_count", format: "count" },
    { name: "transactions_amount", format: "currency" }
  ],
  [
    { name: "chargebacks_count", format: "count" },
    { name: "chargebacks_amount", format: "currency" }
  ],
  [
    { name: "alerts_count", format: "count" },
    { name: "alerts_amount", format: "currency" }
  ],
  [
    { name: "chargeback_rate", format: "percent" },
    { name: "chargeback_rate_without_us", format: "percent-without-us" }
  ],
  [{ name: "prevention_rate", format: "percent" }]
]

const formatFns = {
  count: formatCount,
  currency: formatAmount,
  percent: (rate) => `${rate}%`,
  "percent-without-us": (rate) => `${rate}% without us`,
  blank: () => ""
}

// Only the monetary rows are sensitive: counts and rates stay readable in Incognito mode, the "$"
// volumes are hidden — same split as the table body columns (CHA1-1357).
const isSensitiveFormat = (format) => format === "currency"

const renderSummaryCells = (columns, data) =>
  columns?.map((col, index) => (
    <Table.Summary.Cell index={index + 1} key={col?.[0]?.name}>
      {col?.length > 1 ? (
        <Flex gap={2} vertical={true} align="flex-end">
          <Flex gap={4}>
            <Text strong>
              <Private disabled={!isSensitiveFormat(col[0]?.format)}>
                {formatFns[col[0]?.format]?.(data?.[col[0]?.name] ?? 0)}
              </Private>
            </Text>
            {col[0]?.name === "chargeback_rate" && data?.["chargeback_rate"] > 100 && (
              <ChargebackRateOver100Tooltip />
            )}
          </Flex>
          <Text type="secondary" strong>
            <Private disabled={!isSensitiveFormat(col[1]?.format)}>
              {formatFns[col[1]?.format]?.(data?.[col[1]?.name] ?? 0)}
            </Private>
          </Text>
        </Flex>
      ) : (
        col[0] && (
          <Text strong>
            <Private disabled={!isSensitiveFormat(col[0]?.format)}>
              {formatFns[col[0]?.format]?.(data?.[col[0]?.name] ?? 0)}
            </Private>
          </Text>
        )
      )}
    </Table.Summary.Cell>
  ))

export const createTableSummary =
  (t) => (summary, result, columnsList, comparisonSummary, comparisonLabel) => {
    if (!result?.length) return null
    const columns = columnsList || defaultColumnsList

    return (
      <>
        <Table.Summary.Row className={"summary-row-custom"}>
          <Table.Summary.Cell index={0}>
            <Text type="secondary" strong>
              {t("Summary")}
            </Text>
          </Table.Summary.Cell>
          {renderSummaryCells(columns, summary)}
        </Table.Summary.Row>
        {comparisonSummary && (
          <Table.Summary.Row className={"summary-row-custom compare-row"}>
            <Table.Summary.Cell index={0}>
              <Text type="secondary" strong>
                {t("Compare")} {comparisonLabel || t("previous period")}
              </Text>
            </Table.Summary.Cell>
            {renderSummaryCells(columns, comparisonSummary)}
          </Table.Summary.Row>
        )}
      </>
    )
  }
